<template lang="pug">
  .enrollment-element-user
    .text-h5.ml-3.d-flex
      span.mr-auto {{ user.full_name }}
      tooltip-wrap(text="Как связаться?")
        v-btn(
          color="primary" fab small
          @click="openInfoModal"
        ): v-icon(size="20") mdi-card-account-phone
    .text-caption.ml-3(
      v-if="user.payment_percent"
    ) Оплата по договору:
      v-chip.ml-2(
        small
        :color="user.payment_percent > 50 ? 'success': 'error'"
      ): strong {{ user.payment_percent }}%
      v-btn(text small color="primary" @click="toContract") перейти к договору
        v-icon(right) mdi-file-document
    .mt-5.ml-3.d-flex.align-center.mb-7
      tooltip-wrap(
        :text="user.record.group ? 'Отчислить' : 'Отклонить заявку на зачисление'"
      )
        v-btn(
          color="error darken-1"
          fab
          depressed
          small
          :outlined="!!user.record.group"
          :loading="loading.cancelUser"
          :disabled="user.status === $conf.ATTESTATION_STATUSES.excluded"
          @click="cancelUser"
        ).mr-4
          v-icon(v-if="user.record.group") mdi-account-cancel-outline
          v-icon(v-else) mdi-cancel
      enrollment-element-user-transfer(
        v-if="user.status !== $conf.ATTESTATION_STATUSES.excluded || !user.record.group"
        :user="user"
        :groups="groups"
        :enrollment="enrollment"
        @enrolled="onEnrollUser"
      )
      v-alert.mb-0(
        v-else
        text
        type="error"
        color="error"
      )
        strong(v-if="user.record.group") Пользователь отчислен
        strong(v-else) Заявка отклонена
        div(
          v-if="user.record.group"
        ): a(
          @click="cancelExcludeUser"
        ).caption.secondary--text Отчислен по ошибке?
        .mt-4 Причина:
          span(v-if="!user.record.reason")  Не указана
          span(v-else)  «{{ user.record.reason }}»
    v-list(color="transparent").pt-0.mt-0
      v-list-item(v-if="user.name")
        v-list-item-content.pt-0
          v-list-item-subtitle(
            v-if="course.type === $conf.COURSE_TYPES.general"
          ) Номер сертификата
          v-list-item-title(v-else) Логин
          v-list-item-subtitle {{ user.name }}
      v-list-item(v-if="user.email")
        v-list-item-content
          v-list-item-title Почта
          v-list-item-subtitle {{ user.email }}
      v-list-item(
        v-for="attr in user.attributes"
        :key="attr.id"
        :href="attr.value && attr.value.url"
        target="_blank"
      )
        v-list-item-content
          v-list-item-title {{ attr.name }}
          v-list-item-subtitle(v-if="attr.value")
            template(v-if="attr.type === $conf.INPUT_TYPES.calendar")
              | {{ attr.value | dp('d.MM.yyyy') }}
            template(v-else-if="attr.type === $conf.INPUT_TYPES.file")
              | {{ attr.value.url }}
            template(v-else)
              | {{ attr.value }}
          v-list-item-subtitle(v-else) Не указано
        v-list-item-avatar
          v-menu(
            v-if="attr.value"
          )
            template(#activator="{ on }")
              v-btn(color="primary" v-on="on" icon): v-icon mdi-pencil
            v-list.secondary(dark)
              v-list-item(
                @click="changeAttr(attr)"
              )
                v-list-item-icon: v-icon mdi-pencil
                v-list-item-title Изменить значение
              v-list-item(
                :disabled="loading.cancelAttr[attr.id]"
                @click="cancelAttr(attr)"
              )
                v-list-item-icon: v-icon mdi-cancel
                v-list-item-title Сбросить значение

    v-list(
      v-if="user.statements && user.statements.length > 1 || user.scanRequired"
      color="transparent"
    )
      v-subheader
        .text-uppercase Подписанные заявления
      v-list-item(
        v-for="statement in user.statements"
        v-if="statement.document_name !== 'Заявление на зачисление' || user.scanRequired"
        :key="statement.id"
        :href="statement.user_file && statement.user_file.scan_file_url"
        target="_blank"
      )
        v-list-item-avatar
          v-icon(
            v-if="statement.user_file"
            color="secondary"
          ) mdi-file-document
          v-icon(
            v-else
          ) mdi-file-document-remove
        v-list-item-content
          v-list-item-title {{ statement.document_name }}
          v-list-item-subtitle(
            v-if="statement.user_file"
          )
            span Загружено
          v-list-item-subtitle(
            v-else
          ) Не загружено
        v-btn(
          v-if="user.record.group && statement.user_file"
          color="grey"
          text
          fab
          small
          :loading="loading.cancelStatement[statement.user_file.scan_file_id]"
          @click.prevent="cancelStatement(statement)"
        )
          v-icon mdi-cancel
    .d-flex
      v-btn.ml-auto(
        depressed
        color="error"
        @click="initDelete"
      ) Удалить заявку
</template>

<script>
import { getField } from '@/components/Forms/fields';
import EnrollmentUserInfoModal from './EnrollmentUserInfoModal.vue';
import EnrollmentElementUserTransfer from './EnrollmentElementUserTransfer.vue';

export default {
  components: {
    EnrollmentElementUserTransfer,
  },
  props: {
    course: { type: Object, required: true },
    enrollment: { type: Object, required: true },
    user: { type: [Object, Array], required: true },
    groups: { type: Array, required: true },
  },
  data() {
    return {
      loading: {
        cancelAttr: {},
        cancelStatement: {},
        cancelUser: false,
      },
      info: null,
    };
  },
  watch: {
    user: {
      handler(user) {
        user.setupAttributes(this.enrollment.attributes);
      },
      immediate: true,
    },
  },
  created() {
    this.getUser();
  },
  methods: {
    toContract() {
      const routeData = this.$router.resolve({ name: 'AgreementsList', query: { tab: 1, id: this.info.id } });
      window.open(routeData.href, '_blank');
    },
    changeAttr(attr) {
      this.$modals.show('form-controller', {
        title: 'Изменения аттрибута обучающегося',
        method: ({ data }) => this.$api.courses.editStudentAttr(attr.value_id, {
          value: data[attr.id],
        }),
        successCallback: (data) => { this.$set(attr, 'value', data.value); },
        fields: [getField(attr)],
      });
    },
    openInfoModal() {
      this.$modals.show('generic-controller', {
        title: 'Как связаться',
        component: EnrollmentUserInfoModal,
        'component-props': {
          info: this.info,
        },
      });
    },
    async getUser() {
      // const { item } = await this.$api.users.show(this.user.user_id);
      const { data } = await this.$api.contracts.getContracts({
        expand: 'users',
        'search[user_id]': this.user.user_id,
        'search[is_active]': 1,
        // 'search[owner_id]': this.user.user_id,
        'search[prior_record_id]': this.enrollment.id,
      });
      const [contract] = data.data;
      if (contract) {
        const user = contract.users.find(({ id }) => id === this.user.user_id);
        this.info = {
          telegram: null,
          customer_contact_email: contract.customer_contact_email,
          full_name: user.full_name,
          phone: user.phone,
          address: user.address,
          number: contract.number,
          id: contract.id,
        };
      } else {
        const { email, phone, telegram } = this.user.record.contacts;
        this.info = {
          telegram,
          customer_contact_email: email,
          phone,
        };
      }
      this.info.login = this.user.name;
    },
    async cancelStatement(statement) {
      this.$set(this.loading.cancelStatement, statement.user_file.scan_file_id, true);
      this.$modals.show('confirm-controller', {
        title: 'Откат заявления',
        message: `Ученику потребуется загрузить новое подписанное заявление - ${statement.document_name}`,
        type: 'warning',
        method: () => this.$api.enrollments.cancelStatement(
          statement.user_file.scan_file_id,
        ).then(() => {
          this.$emit('update:statement', { user: this.user, statement, value: null });
        }),
      });
      this.$set(this.loading.cancelStatement, statement.user_file.scan_file_id, false);
    },
    async cancelAttr(attr) {
      this.$set(this.loading.cancelAttr, attr.id, true);
      this.$modals.show('confirm-controller', {
        title: 'Откат значения поля',
        'dialog-props': {
          maxWidth: 500,
        },
        message: `Ученику потребуется указать новое значение в поле "${attr.name}"`,
        type: 'warning',
        method: () => this.$api.enrollments.cancelAttr(
          this.enrollment.id,
          this.user.user_id,
          attr.id,
        ).then(() => {
          this.$emit('update:attribute', { user: this.user, attr, value: null });
        }),
      });
      this.$set(this.loading.cancelAttr, attr.id, false);
    },
    onEnrollUser({ user, group }) {
      this.$emit('update:user', { user, key: 'group', value: group });
    },
    async cancelExcludeUser() {
      this.$modals.show('confirm-controller', {
        title: 'Отмена отчисления',
        message: `${this.user.full_name}`,
        method: () => this.user.changeStatus({ status: this.$conf.ATTESTATION_STATUSES.enrolled }),
      });
    },
    initDelete() {
      this.$modals.show('confirm-controller', {
        title: 'Удаление заявки',
        message: 'Подтвердите удаление заявки',
        method: () => this.$api.enrollments.deleteRecord(this.user.id).then(
          () => this.$emit('delete'),
        ),
      });
    },

    async cancelUser() {
      this.loading.cancelUser = true;
      const hasGroup = !!this.user.record.group;
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: hasGroup ? 'Отчислить' : 'Отклонить заявку',
        message: `${this.user.full_name}`,
        component: 'v-textarea',
        'component-props': {
          rules: 'required',
          label: 'Причина',
          rounded: true,
          filled: true,
          color: 'error',
        },
        method: (data) => this.user.exclude(data)
          .catch(() => { this.$toasted.error('Причина обязательна для заполнения!'); }),
      });
      this.loading.cancelUser = false;
    },
  },
};
</script>
